var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":_vm.localePath({
        name: 'season-maps-overview',
        params: {
            season: _vm.$store.state.currentSeason || 'winter',
        },
    })}},[_c('img',{staticClass:"logo",class:_vm.classes,attrs:{"src":require("assets/images/logo.png"),"alt":"Jungfrau Top of Europe Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }